module.exports = __webpack_public_path__ + "static/media/Close_Icon.12de3433.svg";